import type { NodeEntry } from 'slate';
import { Node } from 'slate';

import { createSignatureField } from './signature-field';
import type { InputFieldElement } from '../../../../slate-api';
import { signatureFieldVariant } from '../../../../slate-api';
import type { DOCXInline } from '../internal';
import { createTextRuns } from '../internal';
import type { BaseDocxOptions } from '../types';

export function createInputField(
  inputFieldEntry: NodeEntry<InputFieldElement>,
  options: BaseDocxOptions
): DOCXInline[] {
  const [inputField, inputFieldPath] = inputFieldEntry;
  const textEntries = [...Node.texts(inputField)];

  switch (inputField.variant) {
    case signatureFieldVariant:
      return createSignatureField([inputField, inputFieldPath], options);
    default:
      return createTextRuns(textEntries, options);
  }
}
